export function matchesEventTimePeriod(time, period) {
  const hour = Number(String(time).split(':')[0]);
  if (!Number.isFinite(hour) || hour < 0 || hour >= 24) return false;
  if (period === 'all') return true;
  return period === 'morning' ? hour >= 6 && hour < 12
    : period === 'afternoon' ? hour >= 12 && hour < 18
    : period === 'evening' ? hour >= 18 : hour < 6;
}
